import { Backpack } from "lucide-react";
import { STAGE_A_APPORTER } from "@/data/site";

export const AApporter = ({ testid = "stage-a-apporter", dark = false, items = STAGE_A_APPORTER, titre = "À apporter le jour du stage" }) => (
  <div className={`rounded-xl border p-4 ${dark ? "border-sand/20 bg-sand/5" : "border-wood/20 bg-sand-dark/40"}`} data-testid={testid}>
    <p className={`font-mono text-[10px] uppercase tracking-[0.25em] mb-3 flex items-center gap-2 ${dark ? "text-sand/70" : "text-terra"}`}>
      <Backpack className="w-3.5 h-3.5" /> {titre}
    </p>
    <ul className={`space-y-1.5 text-xs leading-relaxed ${dark ? "text-sand/75" : "text-fumee"}`}>
      {items.map((t) => <li key={t} className="flex gap-2"><span className="text-terra">·</span>{t}</li>)}
    </ul>
  </div>
);
